import { render, staticRenderFns } from "./GlobalSearchSingleResult.vue?vue&type=template&id=f38ef00c&scoped=true&"
import script from "./GlobalSearchSingleResult.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchSingleResult.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchSingleResult.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GlobalSearchSingleResult.vue?vue&type=style&index=1&id=f38ef00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38ef00c",
  null
  
)

export default component.exports